import IconButton from "@material-ui/core/IconButton";
import BuildIcon from "@material-ui/icons/Build";
import { Menu, MenuItem } from "@material-ui/core";
import ImageIcon from "@material-ui/icons/Image";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import AddIcon from "@material-ui/icons/Add";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import { _post } from "../../../Api";
import { toast } from "react-toastify";
import React from "react";
import UploadImagesArticlesDialog from "../Articles/UploadImagesArticlesDialog";
import articlesStore from "../../../store/articles/ArticlesStore";
import ArticleDetailsBatchEditDialog from "../Articles/ArticleDetailsBatchEditDialog";
import { Articlegroup } from "../../../store/articles/models/Articlegroup";
import { v4 as uuidv4 } from "uuid";
import { setArticlegroups as setArticlegroupsStore } from "../../../store/articles/ArticlesActions";
import EditTextFieldDialog from "../../Dialogs/EditTextFieldDialog";
import cloudStore from "../../../store/CloudStore";
import { useDialog } from "../../Dialogs/DialogProvider";
import withIntl from "../../../utils/withIntl";

function ActionButtonArticlesMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog] = useDialog();

  const handleOpenUploadImagesArticles = () => {
    setAnchorEl(null);
    openDialog({
      children: (
        <UploadImagesArticlesDialog merchantId={articlesStore.merchantId} articlegroups={props.filteredArticlegroups} />
      ),
      fullWidth: true,
      maxWidth: "md",
    });
  };

  const handleOpenBatchUpdate = () => {
    setAnchorEl(null);
    openDialog({
      children: <ArticleDetailsBatchEditDialog />,
      fullWidth: true,
      maxWidth: "md",
      disableBackdropClick: true,
    });
  };

  const handleCreateArticlegroup = () => {
    setAnchorEl(null);

    const handleAddArticlegroup = (newValue) => {
      const newArticlegroup = new Articlegroup();
      newArticlegroup.name = newValue;
      newArticlegroup.priority = Math.min(...props.articlegroups.map((articlegroup) => articlegroup.priority)) - 1;
      const id = uuidv4();
      newArticlegroup.id = id;
      let newArticlegroups = { ...articlesStore.articlegroups, [id]: newArticlegroup };
      setArticlegroupsStore(newArticlegroups);
      props.handleExpansion(newArticlegroup.id);
    };

    openDialog({
      children: (
        <EditTextFieldDialog
          fieldTitle={props.intl.formatMessage({ id: "add_articlegroup" })}
          defaultLanguage={cloudStore.merchant.default_language}
          handleOnClick={handleAddArticlegroup}
          label={props.intl.formatMessage({ id: "group_name" })}
        />
      ),
      fullWidth: true,
      maxWidth: "sm",
    });
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: 10 }}>
      <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} variant="standard">
        <BuildIcon colo={"primary"} />
      </IconButton>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={handleOpenUploadImagesArticles}>
          <ImageIcon color={"primary"} />
          {props.intl.formatMessage({ id: "batch_image_upload" })}
        </MenuItem>
        <MenuItem onClick={handleOpenBatchUpdate}>
          <DynamicFeedIcon color={"primary"} />
          Batch update
        </MenuItem>
        <AuthorizationWrapper
          permission={"add_new_articlegroup"}
          child={
            <MenuItem onClick={handleCreateArticlegroup}>
              <AddIcon color={"primary"} />
              {props.intl.formatMessage({ id: "add_articlegroup" })}
            </MenuItem>
          }
        />
        <AuthorizationWrapper
          permission={"remove_all_images"}
          child={
            <MenuItem
              onClick={() => {
                _post("/nova/v2/merchant/" + articlesStore.merchantId + "/m_articles/remove_images")
                  .then(() => {
                    toast.success("Saved", {
                      position: "bottom-right",
                      autoClose: 2000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                  })
                  .catch(() => {
                    toast.error("Something went wrong.", {
                      position: "bottom-right",
                      autoClose: 2000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                  });
              }}
            >
              <AddIcon color={"primary"} />
              {props.intl.formatMessage({ id: "remove_all_images" })}
            </MenuItem>
          }
        />
      </Menu>
    </div>
  );
}

export default withIntl(ActionButtonArticlesMenu);
